<div class="modal-content" *ngIf="transportForm">
  <div class="modal-body text-center">
    <div class="pb-4">
      <button type="button" class="close pull-right" aria-label="Close" (click)="handleClick({close: true})">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <mdb-icon fas size="4x" [icon]="icon" [class]="iconClass"></mdb-icon>
    <p class="lead mt-4">{{ title }}</p>

    <div class="text-left text-danger">
      <jhi-estimation-my-addresses [isPickup]="isPickup"
                                   [options]="{withoutAddButtons: true, noShadow: true, autocomplete: false, minLengthForSearch: 0, isLightEstimate: isLightEstimate}"
                                   [transportForm]="transportForm"
                                   (selectedAddressChange)="submit()"
      ></jhi-estimation-my-addresses>
    </div>
  </div>

  <!--Footer-->
  <div class="modal-footer justify-content-center">
    <jhi-bary-button [outline]="true"
                     color="primary"
                     [label]="'Annuler'"
                     (clickEvent)="handleClick({cancel: true})"
    ></jhi-bary-button>
  </div>
</div>
